import { connect } from "react-redux";

import { MediaTableController } from "./media-table-controller";

function mapStateToProps(state) {
  const { app, global } = state;

  return {
    contentFolders: app.contentFolders,
    contentGroups: app.contentGroups,
    userContents: global.userContents,
  };
}

const ConnectedMediaTable = connect(mapStateToProps)(MediaTableController);

export { ConnectedMediaTable };
